// FAQ Accordion JS for FeatureFaqPartial1

document.addEventListener('DOMContentLoaded', function () {
    var faqItems = document.querySelectorAll('#feature-faq .faq-card .faq-item');
    faqItems.forEach(function (item) {
        var btn = item.querySelector('.faq-question');
        btn.addEventListener('click', function () {
            var isOpen = item.classList.contains('open');
            // Close all
            faqItems.forEach(function (itm) {
                itm.classList.remove('open');
                itm.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
            });
            // Open this one if it wasn't already open
            if (!isOpen) {
                item.classList.add('open');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });
});
